import React from 'react';
import './index.scss';

const joinClassNames = (...classNames) => classNames.filter(Boolean).join(' ');

export const StickyTable = ({ children, className, ...rest }) => (
  <div className={joinClassNames('sticky-table', className)} {...rest}>
    <div className='sticky-table-table'>{children}</div>
  </div>
);

export const Row = ({ children, className, ...rest }) => (
  <div className={joinClassNames('sticky-table-row', className)} {...rest}>
    {children}
  </div>
);

export const Cell = ({ children, className, ...rest }) => (
  <div className={joinClassNames('sticky-table-cell', className)} {...rest}>
    {children}
  </div>
);
